/* O guia, com TOC lateral fixo e os números vindos da API.
 *
 * O texto continua editorial e escrito à mão, em MDX; só os números viraram
 * componentes. Assim a prosa fica editável sem tocar em TSX, e para de mentir
 * quando a ontologia for reprocessada. */

import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Conteudo from "../guide/conteudo.mdx";
import { components, useGuideMetrics } from "../guide/provider";
import { PageHead } from "../components/ui";
import { fmtDateTime } from "../lib/format";

const SECOES = [
  ["modelo", "O que o grafo é"],
  ["niveis", "Nem toda entidade classifica"],
  ["classificar", "Como usar para classificar"],
  ["conhecer", "O que ele responde além disso"],
  ["armadilhas", "Seis armadilhas"],
  ["rotina", "Uma rotina de meia hora"],
];

export function Guide() {
  const { hash } = useLocation();
  const [active, setActive] = useState("modelo");
  const { data } = useGuideMetrics();

  useEffect(() => {
    if (hash) {
      document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" });
    }
  }, [hash]);

  // Scroll-spy: marca no índice a seção que está sendo lida.
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.filter((e) => e.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
        if (visible) setActive(visible.target.id);
      },
      { rootMargin: "-70px 0px -70% 0px" },
    );
    for (const [id] of SECOES) {
      const node = document.getElementById(id);
      if (node) observer.observe(node);
    }
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <PageHead eyebrow="lendo o grafo de entidades" title="Guia">
        Como ler o grafo, o que ele responde e onde ele engana. Os números desta página são
        calculados sobre os dados atuais, não escritos à mão.
      </PageHead>

      <div className="guide-layout">
        <nav className="guide-toc" aria-label="Índice do guia">
          <ol>
            {SECOES.map(([id, label]) => (
              <li key={id}>
                <a href={`#${id}`} aria-current={active === id ? "true" : undefined}>
                  {label}
                </a>
              </li>
            ))}
          </ol>
          <button className="btn" style={{ marginTop: 16, width: "100%" }}
                  onClick={() => window.print()}>
            imprimir / PDF
          </button>
        </nav>

        <article className="prose">
          <Conteudo components={components} />
          <hr style={{ margin: "34px 0 16px", border: 0, borderTop: "1px solid var(--border-2)" }} />
          <p style={{ fontSize: 12, color: "var(--ink-3)" }}>
            Números apurados sobre <code>input/transactions.csv</code>
            {data ? ` em ${fmtDateTime(data.generated_at)}` : ""}. O texto é editorial; os
            valores vêm de <code>/api/guide/metrics</code>.
          </p>
        </article>
      </div>
    </>
  );
}
